import React, { useEffect, useState } from 'react'
import '../App.css'
import QueryReportForm from './components/QueryReportForm'
import { Image, Stack } from '@mantine/core'
import ReportElements from './components/ReportElements'
import RightFloating from '../components/RightFloating'
import EnhancedHistoryButton from './components/EnhancedHistoryButton'
import ComplaintButton from '../components/ComplaintButton'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { facade } from '../api/orderService'
import { TemplateMerchantInterface } from '../typings/orderTypes'
import InterceptorWrapper from '../components/InterceptorWrapper'
import { getDictByKey } from '../api/dictionaryService'
import { Dialog, Toast } from 'antd-mobile'
import LegalNotice from './components/LegalNotice'

export default function QueryReport() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const linkId = searchParams.get('linkId') || ''
  const [template, setTemplate] = useState<TemplateMerchantInterface>()

  useEffect(() => {
    const init = async () => {
      if (linkId === '') {
        navigate('/login')
        return
      }

      try {
        const whitelistStr = await getDictByKey('key_host_whitelist')
        const whitelist = whitelistStr.split(',')
        const currentHost = window.location.host

        if (!whitelist.includes(currentHost)) {
          Dialog.show({
            content: '当前二维码不可用，请联系商户更换新的查询二维码。',
            closeOnMaskClick: false,
          })
          return
        }

        const res = await facade(linkId)
        setTemplate(res)
      } catch (err) {
        Toast.show('系统错误，请稍后再试')
      }
    }

    init().then()
  }, [linkId, navigate])

  return (
    <InterceptorWrapper>
      <Stack className="max-w-xl m-auto bg-[#F5F5F5] min-h-screen">
        <div className="relative w-full">
          <Image
            src="./banner.png"
            styles={{
              root: { margin: 0, padding: 0, display: 'block', width: '100%' },
            }}
          />
          <div
            className="absolute bottom-0 left-0 right-0 h-16"
            style={{
              background: `linear-gradient(to top, #F5F5F5, transparent)`,
            }}
          />
        </div>
        <Stack className="px-2 pb-4 -mt-12 relative z-10">
          <div className="bg-white rounded-xl px-6 py-4 mb-1">
            <QueryReportForm template={template} />
          </div>
          <div className="bg-white rounded-xl px-6 py-4">
            <ReportElements />
          </div>
          <LegalNotice />
          <RightFloating>
            <Stack align={'flex-end'} gap={0}>
              <EnhancedHistoryButton
                onClick={() => {
                  navigate('/orders')
                }}
                className="rounded-tl-lg"
              />
              <ComplaintButton className="rounded-bl-lg" />
            </Stack>
          </RightFloating>
        </Stack>
      </Stack>
    </InterceptorWrapper>
  )
}
